module.exports = __webpack_public_path__ + "01_long_gray.b0fef933.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/01_long_gray.png
// module id = RBwu
// module chunks = 0